/**
 * 流向异常管理路由
 */

import { RouterView } from 'vue-router'

const anomalyCenterRoutes = {
  path: '/anomaly-center',
  name: 'AnomalyCenter',
  component: RouterView,
  meta: {
    title: '异常管理中心',
    icon: 'WarningOutlined',
    permission: ['anomaly-management']
  },
  children: [
    {
      path: '',
      name: 'AnomalyCenterIndex',
      component: () => import('@/views/anomaly-center/index.vue'),
      meta: {
        title: '异常数据管理',
        keepAlive: true,
        permission: ['anomaly-management']
      }
    },
    {
      path: 'config',
      name: 'AnomalyConfig',
      component: () => import('@/views/anomaly-center/config.vue'),
      meta: {
        title: '异常检测配置',
        keepAlive: false,
        permission: ['anomaly-management']
      }
    }
  ]
}

export default anomalyCenterRoutes